import { useEffect, useState } from "react";
import { Field } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import api from "@/lib/api";

let onbellek = null;
export const hesapOnbellekSifirla = () => { onbellek = null; };

// Tahsilat/ödeme için banka-kasa seçimi; uygun ilk hesabı otomatik seçer.
export const HesapSec = ({ value, onChange, para = "TRY", tur = "", testid = "hesap-sec", label = "Banka / kasa hesabı" }) => {
  const [list, setList] = useState(onbellek || []);
  useEffect(() => {
    if (!onbellek) api.get("/hesaplar/secenekler").then((r) => { onbellek = r.data; setList(r.data); }).catch(() => setList([]));
  }, []);
  const uygun = list.filter((h) => h.para_birimi === para && (tur ? (tur === "nakit" ? h.tip === "kasa" : h.tip === "banka") : true));
  useEffect(() => {
    if (!uygun.find((h) => h.id === value)) {
      const ilk = uygun.find((h) => h.tip === (tur === "nakit" ? "kasa" : "banka")) || uygun[0];
      onChange(ilk ? ilk.id : "");
    }
  }, [para, tur, list.length]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Field label={label}>
      <SelectBox testid={testid} value={value} onChange={onChange} placeholder={uygun.length ? "Seçin" : `Uygun ${para} hesabı yok`}
        options={uygun.map((h) => ({ value: h.id, label: `${h.ad} · ${h.tip === "kasa" ? "kasa" : "banka"}` }))} />
    </Field>
  );
};
